import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/front-user/shared/models/user.model';
import { FormGroup, FormBuilder, FormArray, FormControl, Validators } from '@angular/forms';
import { AgentCurrencyDto, AgentCurrencyListDto } from '../../shared/models/agent-currency.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationAdminService } from '../../shared/services/registration-admin.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { Languages, FormMode, ServiceStatus } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';

@Component({
  selector: 'app-enter-treasury-numbers',
  templateUrl: './enter-treasury-numbers.component.html',
  styleUrls: ['./enter-treasury-numbers.component.css']
})
export class EnterTreasuryNumbersComponent implements OnInit {
  user: User = new User();
  registerTreasuryNumberForm: FormGroup;
  displayedLang: string;
  baseRequestId: string = '';
  submitted = false;
  loading = false; requestStatus: number;
  agentId: string;
  isErrorMessage: boolean = false;

  getAgentCurrency: AgentCurrencyDto[] = [];
  error: any = { isError: false, errorMessage: '' };
  agentCurrency: AgentCurrencyDto[] = [];
  isReadOnly = true;
  agentCurrencyList: AgentCurrencyListDto = new AgentCurrencyListDto();
  baseRequestDTO: BaseRequest;
  showRequest = false;

  public FormMode: any = FormMode;
  public formMode = FormMode.Add;
  lockTaskErrorMessage: boolean = false;
  DuplicateTreasuryNumber: boolean= false;

  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices, private alertService: AlertService,
    private route: ActivatedRoute, private adminSrv: RegistrationAdminService, private router: Router,
    private translate: TranslateService,
    private authenticationService: AuthenticationService,
    private baseRequestService: BaseRequestService, ) {

    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    // this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;

    }else{
      window.history.back();
    }
    this.user = this.authenticationService.currentUserValue;

  }

  ngOnInit() {

    this.buildForm();
  }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        if (d.Success) {
          this.baseRequestDTO = d.Data;
          this.requestStatus = this.baseRequestDTO.StatusId;
          this.agentId = this.baseRequestDTO.RequestorId;
          this.baseRequestId = this.baseRequestDTO.Id;
          this.adminSrv.getAgentCurrency(this.agentId)
            .subscribe((data: ResponseObject) => {

              this.agentCurrency = data.Data as AgentCurrencyDto[];
              if (this.requestStatus == ServiceStatus.PendingOnTreasuryNumbers) {
                this.agentCurrency = this.agentCurrency.filter(item => item.TreasuryNumber == null);
              }
              this.bindAttachments(this.agentCurrency);
              // this.registerTreasuryNumberForm.setControl('AgentCurrencyDto', this.bindAttachments(this.agentCurrency));
            }
            );
        }
      }
    )
  }

  buildForm() {
    this.registerTreasuryNumberForm = this.formBuilder.group({
      AgentCurrencyDto: this.formBuilder.array([]),
    });

    this.getBaseRequest();
  }


  get Currency() {
    return this.registerTreasuryNumberForm.get('AgentCurrencyDto') as FormArray;
  }

  bindAttachments(currency): any {
    let control = <FormArray>this.registerTreasuryNumberForm.controls['AgentCurrencyDto'];
    currency.forEach((key) => {
      if (history.state.data && history.state.data.isCompleted) {
        if (this.globalSrv.getLanguage() == Languages.Arabic) {
          control.push(new FormGroup({
            CurrencyName: new FormControl({ value: key.Currency.NameAR, disabled: true }),
            TreasuryNumber: new FormControl({ value: key.TreasuryNumber, disabled: true }),
            CurrencyId: new FormControl({ value: key.CurrencyId }),
            Id: new FormControl({ value: key.Id }),
            AgentId: new FormControl({ value: key.AgentId })
          }));
        }
        if (this.globalSrv.getLanguage() == Languages.English) {
          control.push(new FormGroup({
            CurrencyName: new FormControl({ value: key.Currency.NameEN, disabled: true }),
            TreasuryNumber: new FormControl({ value: key.TreasuryNumber, disabled: true }),
            CurrencyId: new FormControl({ value: key.CurrencyId }),
            Id: new FormControl({ value: key.Id }),
            AgentId: new FormControl({ value: key.AgentId })
          }));
        }
        this.formMode = FormMode.Readonly;
        this.registerTreasuryNumberForm.disable();
      }
      else if (this.requestStatus == ServiceStatus.PendingOnTreasuryNumbers) {

        if (this.globalSrv.getLanguage() == Languages.Arabic) {
          control.push(new FormGroup({
            CurrencyName: new FormControl({ value: key.Currency.NameAR, disabled: true }),
            TreasuryNumber: new FormControl('', Validators.required),
            CurrencyId: new FormControl({ value: key.CurrencyId }),
            Id: new FormControl({ value: key.Id }),
            AgentId: new FormControl({ value: key.AgentId })
          }));
        }
        if (this.globalSrv.getLanguage() == Languages.English) {
          control.push(new FormGroup({
            CurrencyName: new FormControl({ value: key.Currency.NameEN, disabled: true }),
            TreasuryNumber: new FormControl('', Validators.required),
            CurrencyId: new FormControl({ value: key.CurrencyId }),
            Id: new FormControl({ value: key.Id }),
            AgentId: new FormControl({ value: key.AgentId })
          }));
        }
      }

      else {

        if (this.globalSrv.getLanguage() == Languages.Arabic) {
          control.push(new FormGroup({
            CurrencyName: new FormControl({ value: key.Currency.NameAR, disabled: true }),
            TreasuryNumber: new FormControl({ value: key.TreasuryNumber, disabled: true }),
            CurrencyId: new FormControl({ value: key.CurrencyId }),
            Id: new FormControl({ value: key.Id }),
            AgentId: new FormControl({ value: key.AgentId })
          }));
        }
        if (this.globalSrv.getLanguage() == Languages.English) {
          control.push(new FormGroup({
            CurrencyName: new FormControl({ value: key.Currency.NameEN, disabled: true }),
            TreasuryNumber: new FormControl({ value: key.TreasuryNumber, disabled: true }),
            CurrencyId: new FormControl({ value: key.CurrencyId }),
            Id: new FormControl({ value: key.Id }),
            AgentId: new FormControl({ value: key.AgentId })
          }));
        }
        this.formMode = FormMode.Readonly;
        this.registerTreasuryNumberForm.disable();
      }
    });
    return control;
  }


  transformCurrency(Currencies): AgentCurrencyListDto {
    Object.keys(Currencies).forEach((key) => {
      let value = Currencies[key];
      value.forEach(element => {
        element.CurrencyId = element.CurrencyId.value;
        element.AgentId = element.AgentId.value;
        element.Id = element.Id.value;
        element.TreasuryNumber = element.TreasuryNumber;
        this.agentCurrencyList.AgentCurrencyDto.push(element);
      });
    });
    return this.agentCurrencyList;
  }


  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.registerTreasuryNumberForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;

    this.agentCurrencyList = this.transformCurrency(this.registerTreasuryNumberForm.value);
    this.agentCurrencyList.AdminEmail = this.user.UserName;
    this.agentCurrencyList.RequestId = this.baseRequestId;
    this.agentCurrencyList.AgentId = this.agentId

    this.adminSrv.UpdateProfileTreasuryNumbers(this.agentCurrencyList)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.registerTreasuryNumberForm.reset();
            this.showRequest = true;
            this.isErrorMessage = false;
          } else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }  else if (data.ErrorMessages.find(e => e == "DuplicateTreasuryNumber") != null) {
            this.globalSrv.isLoaderEnabled = false;
            this.DuplicateTreasuryNumber = true;
            this.showRequest = true;
          }else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]));

          }

        });
  }


  onChangeTreasury(event, control) {

    let treasuryNumber = event.target.value;
    if (treasuryNumber) {
      this.adminSrv.CheckTreasuryNumber(treasuryNumber).subscribe((data: ResponseObject) => {
        if (!data.Success) {
          control.setErrors({ duplicatedNumber: true });
        }
        else {
          control.setErrors(null);
          control.setValidators([Validators.required]);
          control.updateValueAndValidity();
        }

      });
    }
  }

}
